import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TriggerEnum } from '../models/trigger.enum';
import { Subject, Observable } from 'rxjs';
import { Store, Actions, ofActionDispatched } from '@ngxs/store';
import { EngineService } from 'src/app/engine/engine.service';
import { CameraService } from 'src/app/engine/camera.service';
import { createTrigger } from '../utils/triggers';
import { delay, takeUntil, take, flatMap, skipUntil } from 'rxjs/operators';
import { trigger, transition, useAnimation } from '@angular/animations';
import { AnimationLib } from 'src/app/shared/libraries/animations/animation-lib';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { SetCamera, SetCameraSuccess } from 'src/app/engine/state/camera/engine.camera.actions';
import { ViewState } from 'src/app/view/state/view.state';

declare const Human: any;

@Component({
  selector: 'app-view-tour-slide',
  templateUrl: './view-tour-slide.component.html',
  styleUrls: ['./view-tour-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('refresh', [
      transition(':enter', [
        useAnimation(AnimationLib.slideTransition, {
          params: {
            duration: 500,
            from: 100,
            to: 0
          }
        })
      ])
    ])
  ]
})
export class ViewTourSlideComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  title: string;

  @Input()
  image: string;

  @Input()
  spacing: 'compact' | 'expanded' = 'compact';

  @Input()
  set shown(value: boolean) {
    this._shown = value;
    this.initTrigger();
    this.changeRef.markForCheck();
  }
  get shown(): boolean {
    return this._shown;
  }

  @Input()
  exitEnabled = true;

  @Input()
  trigger: TriggerEnum;

  @Input()
  triggerDelay = 300;

  @Output()
  triggerComplete = new EventEmitter();

  private _shown = false;
  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private actions: Actions,
    private engineService: EngineService,
    private cameraService: CameraService,
    private changeRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.initTrigger();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private initTrigger() {
    // clear any subscriptions
    this.ngUnsubscribe.next();

    // build trigger
    if (this.shown && this.trigger) {

      // reset camera before trigger
      const resetCamera$ = this.resetCamera();

      // get touch state
      const touch = this.store.selectSnapshot(ViewState.getCanTouch);

      // create trigger
      createTrigger(this.trigger, this.store, this.engineService, this.cameraService, touch)
        .pipe(
          skipUntil(resetCamera$),
          delay(this.triggerDelay),
          takeUntil(this.ngUnsubscribe)
        )
        .subscribe(() => {
          this.triggerComplete.next();
        });
    }
  }

  private resetCamera(): Observable<any> {
    // manually reset to chapter camera
    const chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
    return this.store.dispatch(new SetCamera(chapter.camera.location, true))
      .pipe(
        flatMap(() => this.actions
          .pipe(
            ofActionDispatched(SetCameraSuccess)
          )),
        take(1)
      );
  }

}
